module.exports = __webpack_public_path__ + "img/6.95dd8eb5.png";